import React from 'react';
import BackupForm from '../../components/backup/BackupForm';

const ScheduleBackupPage = () => {
  return (
    <div>
      <BackupForm scheduleMode={true} />
    </div>
  );
};

export default ScheduleBackupPage;